import { __rest } from "tslib";
import { useFocusable } from '../../interactions/focusable';
import { usePress } from '../../interactions/press';
import { mergeProps } from '../../libs/merge-props';
import { isFirefox } from '../../libs/platform';
// TODO: Add validation for exists aria-label or aria-labelledby.
export function useToggle(props, inputRef) {
    var onChange = props.onChange, readOnly = props.readOnly, state = props.state, restProps = __rest(props, ["onChange", "readOnly", "state"]);
    var focusableProps = useFocusable(props, inputRef).focusableProps;
    var _a = usePress(props), isPressed = _a.isPressed, pressProps = _a.pressProps;
    return {
        isPressed: isPressed,
        rootProps: pressProps,
        inputProps: mergeProps(restProps, focusableProps, {
            'aria-checked': props.checked,
            'aria-invalid': state === 'invalid' || undefined,
            // Use "aria-readonly" because "readOnly" available only for text fields,
            // see https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/readonly.
            'aria-readonly': readOnly || undefined,
            // https://bugzilla.mozilla.org/show_bug.cgi?id=654072
            autoComplete: isFirefox() ? 'off' : undefined,
            onChange: readOnly ? undefined : onChange,
            type: 'checkbox',
        }),
    };
}
